import { trimAndAddAsterisk } from '../utility/QueryUtility';

export const fetchNaicsCodesParamsMapping = [
  { path: 'page' },
  { path: 'size' },
  {
    path: 'search',
    transform: ({ search }: any) =>
      search ? trimAndAddAsterisk(search) : null,
  },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      switch (orderBy) {
        case 'coverageLimit':
        case 'industryClass':
        case 'isSupported':
          if (orderBy && order) {
            return `${orderBy},${order}`;
          }
          break;
        default:
          if (orderBy && order) {
            return `${orderBy}.keyword,${order}`;
          }
      }

      return null;
    },
  },
  { path: 'dup' },
];
